module.exports = __webpack_public_path__ + "static/media/engLogo.aac0dfef.png";